import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss'],
})
export class DeleteAccountComponent implements OnInit {
  constructor(
    private modalCtrl: ModalController,
    private userService: UserService
  ) {}

  ngOnInit() {}

  public dismiss() {
    this.modalCtrl.dismiss({
      dismissed: true,
    });
  }

  async deleteAccount() {
    const userId = await this.userService.userId;
    console.log(userId);
    this.userService.deleteAccount(userId).then((res) => {
      // response status is 204 when successful
      this.modalCtrl.dismiss({
        status: res.status,
      });
    });
  }
}
